import { render, staticRenderFns } from "./productListEBook.vue?vue&type=template&id=4c8c4f80&scoped=true&"
import script from "./productListEBook.vue?vue&type=script&lang=js&"
export * from "./productListEBook.vue?vue&type=script&lang=js&"
import style0 from "./productListEBook.vue?vue&type=style&index=0&id=4c8c4f80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c4f80",
  null
  
)

export default component.exports